import { render, staticRenderFns } from "./CustomDialogShowDetail.vue?vue&type=template&id=4d893126&scoped=true&"
import script from "./CustomDialogShowDetail.vue?vue&type=script&lang=js&"
export * from "./CustomDialogShowDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomDialogShowDetail.vue?vue&type=style&index=0&id=4d893126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d893126",
  null
  
)

export default component.exports